import { render, staticRenderFns } from "./PaymentPlanBlock.vue?vue&type=template&id=b13ff65c&scoped=true"
import script from "./PaymentPlanBlock.vue?vue&type=script&lang=js"
export * from "./PaymentPlanBlock.vue?vue&type=script&lang=js"
import style0 from "./PaymentPlanBlock.vue?vue&type=style&index=0&id=b13ff65c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13ff65c",
  null
  
)

export default component.exports